module.exports = __webpack_public_path__ + "static/media/3d_logo.837de64a.jpg";